import '../../styles/success.css';

export default function Success() {
    return (
        <div className="success">
            <div className="icon">
                <div className="swal-icon swal-icon--success">
                    <span className="swal-icon--success__line swal-icon--success__line--long"></span>
                    <span className="swal-icon--success__line swal-icon--success__line--tip"></span>
                    <div className="swal-icon--success__ring"></div>
                    <div className="swal-icon--success__hide-corners"></div>
                </div>
            </div>
            <h2>Pomyślnie dodano.</h2>
            <h1>Wkrótce skontaktujemy się z Tobą!</h1>
        </div>
    )
};